import { CaptureValueType } from '../../enum';

export class CaptureSettingsDto {
  id: number;
  parentId?: number;
  key: string;
  name: string;
  description?: string;
  valueType: CaptureValueType;
  defaultValue: string;
  level: number;
  sequence: number;
  children?: CaptureSettingsDto[];
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;
}